import { Navigate, useParams } from 'react-router-dom'
import { getSeoPageByPath } from '@/data/seoCatalog'
import SeoEntityPage from '@/pages/SeoEntityPage'

export function RepairCategoryPage() {
  const { categoryId } = useParams<{ categoryId: string }>()
  const page = getSeoPageByPath(`/repair/${categoryId}`)
  if (!page) return <Navigate to="/book-repair" replace />
  return <SeoEntityPage page={page} />
}

export function RepairBrandPage() {
  const { categoryId, brandId } = useParams<{ categoryId: string; brandId: string }>()
  const page = getSeoPageByPath(`/repair/${categoryId}/${brandId}`)
  if (!page) return <Navigate to={`/repair/${categoryId}`} replace />
  return <SeoEntityPage page={page} />
}

export function RepairModelPage() {
  const { categoryId, brandId, modelSlug } = useParams<{
    categoryId: string
    brandId: string
    modelSlug: string
  }>()
  const page = getSeoPageByPath(`/repair/${categoryId}/${brandId}/${modelSlug}`)
  if (!page) return <Navigate to={`/repair/${categoryId}/${brandId}`} replace />
  return <SeoEntityPage page={page} />
}

export function ProductSeoPage() {
  const { productSlug } = useParams<{ productSlug: string }>()
  const page = getSeoPageByPath(`/products/${productSlug}`)
  if (!page) return <Navigate to="/accessories" replace />
  return <SeoEntityPage page={page} />
}

export function RecyclingTopicPage() {
  const { topicSlug } = useParams<{ topicSlug: string }>()
  const page = getSeoPageByPath(`/recycling/${topicSlug}`)
  if (!page) return <Navigate to="/recycling" replace />
  return <SeoEntityPage page={page} />
}
